import { styled } from "@mui/material/styles";
const MapMain = styled("div")(({ theme }) => ({
  marginTop: "30px",
  marginBottom: "30px",
  // height: "370px",
  overflow: "hidden",
  border: "1px solid #D1D1D1",
  [theme.breakpoints.down("md")]: {
    height: "250px",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.05)",
    borderRadius: "12px",
    marginBottom: "10px",
  },
}));
const PriceSec = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "& .price_sec": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "20px",
      lineHeight: "130%",
      color: "#191D31",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .time_sec": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "& h6": {
      fontFamily: theme.typography.fontFamily,
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "20px",
      lineHeight: "20px",
      color: "#0B0B0B",
    },
    "& span": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "18px",
      textAlign: "right",
      color: "rgba(11, 11, 11, 0.75)",
      fontFamily: theme.typography.fontFamily,
    },
  },
  [theme.breakpoints.down("md")]: {
    marginBottom: "20px",
  },
}));

const MoreDetails = styled("div")(({ theme }) => ({
  marginTop: "20px",
  marginBottom: "50px",
  "& .pickup_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "20px",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      left: "13px",
      top: "100%",
      height: "64%",
      width: "1px",
      borderLeft: "2px dashed rgba(11, 11, 11, 0.5)",
    },
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "20.7649px",
      lineHeight: "130%",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .drop_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "15px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "20.7649px",
      lineHeight: "130%",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  [theme.breakpoints.down("md")]: {
    "& .drop_ItemMain": {
      gap: "10px",
      marginBottom: "10px",
      "& span": {
        fontSize: "15px",
      },
    },
    "& .pickup_ItemMain": {
      gap: "10px",
      marginBottom: "10px",
      "& span": {
        fontSize: "15px",
      },
    },
  },
}));

export { MapMain, PriceSec, MoreDetails };
